import { render, staticRenderFns } from "./InfosRegister.vue?vue&type=template&id=5b2afab9&scoped=true&"
import script from "./InfosRegister.vue?vue&type=script&lang=js&"
export * from "./InfosRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2afab9",
  null
  
)

export default component.exports